import * as React from 'react';

import { useIntl } from 'react-intl';

import SimulateDisplayRequestFormModal from 'src/features/actions/components/form/SimulateDisplayRequestFormModal';
import SimulateLPRDetectionFormModal from 'src/features/actions/components/form/SimulateLPRDetectionFormModal';
import { actionsMessages } from 'src/features/actions/utils/messages';
import {
    GeneralBlockHead,
    GeneralBlockHeader,
    GeneralBlockSubtitle,
    GeneralBlockTitle,
} from 'src/registry/components/blocks/GeneralBlock';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import { useTitleStore } from 'src/stores/useTitleStore';
import { ICON_MAP } from 'src/utils/constants';

const Actions = () => {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();
    const [isLPRModalOpen, setIsLPRModalOpen] = React.useState<boolean>(false);
    const [isDisplayMessageModalOpen, setIsDisplayMessageModalOpen] = React.useState<boolean>(false);

    React.useEffect(() => {
        setTitle(formatMessage(actionsMessages.actions));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);
    return (
        <>
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(actionsMessages.lpr)}</SectionBlockTitle>
                        <SectionBlockSubtitle className="max-w-fit">
                            {formatMessage(actionsMessages.lprSectionDescription)}
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="grid grid-cols-1 lg:grid-cols-2">
                    <Button
                        onClick={() => setIsLPRModalOpen(true)}
                        variant="outline"
                        className="flex h-auto min-w-full cursor-pointer justify-start gap-4 rounded-xl border border-gray-200 bg-white p-4 text-left font-normal hover:bg-gray-100"
                    >
                        <GeneralBlockHeader>
                            <SquareIcon icon={ICON_MAP.CAMERA} />
                            <GeneralBlockHead>
                                <GeneralBlockTitle className="text-base text-gray-900">
                                    {formatMessage(actionsMessages.lprDetection)}
                                </GeneralBlockTitle>
                                <GeneralBlockSubtitle>
                                    {formatMessage(actionsMessages.lprDetectionDescription)}
                                </GeneralBlockSubtitle>
                            </GeneralBlockHead>
                        </GeneralBlockHeader>
                    </Button>
                </SectionBlockBody>
            </SectionBlock>
            {isLPRModalOpen && (
                <SimulateLPRDetectionFormModal isModalOpen={isLPRModalOpen} setIsModalOpen={setIsLPRModalOpen} />
            )}
            <SectionBlock>
                <SectionBlockHeader>
                    <SectionBlockHead>
                        <SectionBlockTitle>{formatMessage(actionsMessages.display)}</SectionBlockTitle>
                        <SectionBlockSubtitle className="max-w-fit">
                            {formatMessage(actionsMessages.displaySectionDescription)}
                        </SectionBlockSubtitle>
                    </SectionBlockHead>
                </SectionBlockHeader>
                <SectionBlockSeparator />
                <SectionBlockBody className="grid grid-cols-1 lg:grid-cols-2">
                    <Button
                        onClick={() => setIsDisplayMessageModalOpen(true)}
                        variant="outline"
                        className="flex h-auto min-w-full cursor-pointer justify-start gap-4 rounded-xl border border-gray-200 bg-white p-4 text-left font-normal hover:bg-gray-100"
                    >
                        <GeneralBlockHeader>
                            <SquareIcon icon={ICON_MAP.MESSAGE} />
                            <GeneralBlockHead>
                                <GeneralBlockTitle className="text-base text-gray-900">
                                    {formatMessage(actionsMessages.displayMessage)}
                                </GeneralBlockTitle>
                                <GeneralBlockSubtitle>
                                    {formatMessage(actionsMessages.sendMessageToDisplay)}
                                </GeneralBlockSubtitle>
                            </GeneralBlockHead>
                        </GeneralBlockHeader>
                    </Button>
                </SectionBlockBody>
            </SectionBlock>
            {isDisplayMessageModalOpen && (
                <SimulateDisplayRequestFormModal
                    isModalOpen={isDisplayMessageModalOpen}
                    setIsModalOpen={setIsDisplayMessageModalOpen}
                />
            )}
        </>
    );
};

export default Actions;
